import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { LoyaltyProfile, TokenizedPaymentCard } from '@/models';
import { Promotion } from '@/models';
import { formatGiftCardNumberWithSpaces, getVibesSmartLinkBaseUrl } from '@/helpers';

@Component({
  name: 'CmgLoyaltyRewardCard',
})
export default class CmgLoyaltyRewardCard extends Vue {
  @Prop({ required: false, default: null, type: Object })
  member?: LoyaltyProfile;

  @Prop({ required: false, default: null, type: Object })
  promotion?: Promotion;

  @Prop({ required: false, default: null, type: Object })
  giftCard?: TokenizedPaymentCard;

  @Prop({ required: false, default: 0, type: Number })
  balance?: number;

  get isOniPhone() {
    return this.$services.utils.iOSDevice()
  }
  get isOnAndroid(): boolean {
    return this.$services.utils.androidDevice()
  }

  get addToWalletImageUrl(): string {
    if (this.isOniPhone) {
      return this.$appStore.state.cms.images.buttons.addToAppleWallet.default;
    }
    if (this.isOnAndroid) {
      return this.$appStore.state.cms.images.buttons.googlePaySaveToPhone.default;
    }
    return '';
  }

  formatGiftCardNumber(giftCardNumber: string) {
    return formatGiftCardNumberWithSpaces(giftCardNumber);
  }

  formatPrice(price: number | null): string {
    return this.$services.utils.formatPrice(price);
  }

  onClickAddToWallet(): void {
    const { profile } = this.$store.state.customer;
    const { firstName, lastName, email } = profile;
    const loyaltyId = profile && this.$services.loyalty.getLoyaltyProfile(profile)?.memberId;

    if(loyaltyId) {
      this.$services.loyalty.getVibesSmartLink(loyaltyId)
        .then((data) => {
          const url = `${getVibesSmartLinkBaseUrl()}?${data}`;
         window.open(url, '_self');
        });    
    }
  }

}
